import React from 'react'
import WhuImg from '../../../../../assets/img/work_face.webp'

function WorkforceManagementsec2() {
  return (
    <section className='whu-sec'>
        <div className='container'>
            <div className='ffr-sec'>
                <div className='ffr-head'>
                    <h3>Why Choose </h3>
                    <h4>Workface?</h4>
                </div>
                <div className='ffr-desc'>
                    <p>Our commitment to excellence and innovation sets us apart. Workface is a software solution; it is an essential add-on that helps businesses optimize their human resource management, finance operations, remote workforce tracking, and more—all while working alongside your current systems.</p>
                </div>
            </div>
            <div className='whu-sec1'>
                <div className='whulft'><img src={WhuImg} alt='Why Choose Workface' width={800} height={600} loading="lazy"/></div>
                <div className='whurgt'>
                    <h3>Key Features</h3>
                    <ul>
                        <li><b>Remote Attendance Tracking</b> - Employees can log attendance from anywhere, supported by geolocation validation for transparency.</li>
                        <li><b>Finance Payout Automation</b> - Simplify salary processing, reimbursements, and vendor payments with accurate and timely execution.</li>
                        <li><b>Geolocation & Workforce Mobility</b> - Monitor employee locations securely while managing field operations seamlessly.</li>
                        <li><b>Seamless Integration</b> - Works effortlessly with existing ERP, payroll, and HR management systems.</li>
                        <li><b>Mobile Scanning & Registration</b> - A user-friendly app for quick and accurate employee tracking.</li>
                        <li><b>Real-time Data Insights</b> - Gain actionable insights for improved decision-making.</li>
                        <li><b>Scalable & Future-Ready</b> - Adapts to business growth and changing workforce dynamics.</li>
                    </ul>
                </div>
            </div>
        </div>
    </section>
  )
}

export default WorkforceManagementsec2
